import { Spinner } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { activityLogActions } from '../actions/activityLog';

import styles from './activityLog.module.scss';
import { ComponentByLogType } from './activityTypes';

/**
 * Represents a component that outputs the log entries for the main
 * conversation.
 */
export function ActivityLog(): JSX.Element {
  const dispatch = useAppDispatch();
  const {
    metaConversation: { conversation, messages },
    activityLog: { entries, asyncStatus },
  } = useAppSelector(
    (state) => ({
      metaConversation: state.conversation.metaConversation,
      activityLog: state.activityLog,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (conversation.id) {
      dispatch(activityLogActions.get({ csid: conversation.id }));
    }
  }, [conversation.id]);

  return (
    <div
      className={classnames({
        [styles.root]: true,
        [styles.hasLogs]: entries.length,
      })}
    >
      {asyncStatus === 'loading' && (
        <div className={styles.spinnerContainer} data-testid="spinner">
          <Spinner />
        </div>
      )}
      {asyncStatus === 'failed' && (
        <span className={styles.error}>Failed to retrieve Activity Log.</span>
      )}
      {asyncStatus === 'succeeded' &&
        (entries.length
          ? entries.map((entry) => (
              <ComponentByLogType
                key={entry.event_id}
                entry={entry}
                messages={messages}
              />
            ))
          : 'No events to display.')}
    </div>
  );
}
